import React from 'react';
import { QueryQuote } from '@tassomutuo-backoffice/types';
import configEnv from '../../../../config/config';
import { Tooltip } from '@mui/material';
import ReportIcon from '@mui/icons-material/Report';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import _ from 'lodash';
import WarningIcon from '@mui/icons-material/Warning';

interface IProps {
  queryQuote: QueryQuote;
  prodQuoteQueries: QueryQuote[];
}
const QuoteQueriesTableStatusTassoRenderCell = ({
  queryQuote,
  prodQuoteQueries,
}: IProps) => {
  const queryQuoteInProd = prodQuoteQueries?.find(
    (q) => q.id === queryQuote.id
  );

  if (!configEnv.isStage) {
    return <CheckCircleIcon color="success" />;
  }

  if (!queryQuoteInProd) {
    return (
      <Tooltip title="Preventivo NON in produzione">
        <ReportIcon color="error" />
      </Tooltip>
    );
  }

  if (_.isEqual(queryQuoteInProd.queryBody, queryQuote.queryBody)) {
    return (
      <Tooltip title="Produzione sincronizzata">
        <CheckCircleIcon color="success" />
      </Tooltip>
    );
  }

  return (
    <Tooltip title="Produzione non aggiornata">
      <WarningIcon color="warning" />
    </Tooltip>
  );
};

export default QuoteQueriesTableStatusTassoRenderCell;
